import permissions from '../permissions'

const COMMITTEE_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.COMMITTEES.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.COMMITTEES.MANAGE,
  },
]

export default COMMITTEE_LIST
